import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=642008ea"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('642008ea')) {
      api.createRecord('642008ea', component.options)
    } else {
      api.reload('642008ea', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=642008ea", function () {
      api.rerender('642008ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/Header.vue"
export default component.exports